let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2waI9")).then(() => parcelRequire('3U2yH'));